module.exports = __webpack_public_path__ + "img/kang.c5bc40ef.png";